/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.hint-message-drag[_ngcontent-%COMP%] {\n  text-align: right;\n  padding: 8px; }\n\n.text-info[_ngcontent-%COMP%] {\n  width: 100%; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvcHJvZmlsZS1zdXJ2ZXktb2JzZXJ2YXRpb25zL25ldy1wcm9maWxlLXN1cnZleS1vYnNlcnZhdGlvbi9uZXctcHJvZmlsZS1zdXJ2ZXktb2JzZXJ2YXRpb24uY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvcHJvZmlsZS1zdXJ2ZXktb2JzZXJ2YXRpb25zL25ldy1wcm9maWxlLXN1cnZleS1vYnNlcnZhdGlvbi9uZXctcHJvZmlsZS1zdXJ2ZXktb2JzZXJ2YXRpb24uY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/profile-survey-observations/new-profile-survey-observation/new-profile-survey-observation.component.scss.shim.ngstyle.ts